module.exports = __webpack_public_path__ + "static/e4c67c2fc9d90cc92c0607187af71666.png";